/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SystemDirections {
    None = '0',
    In = 1,
    Out = 2,
}
